import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import { waLink, WHATSAPP_DISPLAY } from '../data/whatsapp';

const { FaWhatsapp } = FaIcons;

function Contact() {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-inner">
        <span className="eyebrow">Your next chapter starts here</span>
        <h2>Make room<br />for <em>stronger.</em></h2>
        <p>No perfect time. Just your time. Reach out and we'll help you find the right place to start.</p>
        <a className="contact-wa" href={waLink()} target="_blank" rel="noreferrer">
          <span className="wa-icon"><SafeIcon icon={FaWhatsapp} /></span>
          <span className="wa-text"><strong>Contact Us</strong><small>{WHATSAPP_DISPLAY}</small></span>
          <span className="wa-arrow">↗</span>
        </a>
        <div className="contact-meta">
          <span>123 Foundry Lane, Your City</span>
          <span>Mon–Sun · 5:30 AM – 11:00 PM</span>
        </div>
      </div>
    </section>
  );
}
export default Contact;
